import TransactionStatsCard from './transaction-stats';
import ButtonAdd from 'components/Global/ButtonAdd';
import { PaginationTable, Table, TableWrapper } from 'components/Global';
import LoadingSpinner from 'components/Global/LoadingSpinner';
import EmptyState from 'components/Global/EmptyState';
import { ReactComponent as PeopleIcon } from 'icons/people-filled-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { deleteInfluencer, getInfluencer, getTotalInfluencer, getTransactionStats } from 'features/influencer/actions';
import { trackEvent } from 'utils/analytics';
import { checkPermission } from 'utils/functionality';
import { useAppContext } from 'components/Context/AppContext';
import { useNavigate } from 'react-router-dom';
import InfluencerStats from './influencer-stats';
import { format } from 'date-fns';

const COLUMN = [
  { header: 'No.', value: 'no' },
  { header: 'Nama Lengkap', value: 'name' },
  { header: 'Generate Link', value: 'referral_link' },
  { header: 'Masa Aktif', value: 'active_period' },
  { header: 'Status User', value: 'user_status' },
];

const InfluencerPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get('page')) || 1;

  const { setShowConfirmation, setShowSpinner, showToast } = useAppContext();
  const { offCanvasMenu, currentMenu } = useSelector((state) => state.menu);

  const { list, isLoading } = useSelector((state) => state.influencer);

  useEffect(() => {
    dispatch(getInfluencer(page));
  }, [page]);

  const handleAdd = () => {
    navigate('/influencer/add');
  };

  const handleDelete = (e) => {
    const userId = e.target.parentElement.parentElement.dataset['key'];

    setShowConfirmation({
      message: 'Apakah anda yakin ingin menghapus User?',
      show: true,
      onClick: async () => {
        try {
          setShowSpinner(true);
          trackEvent('influencer_deleted', { influencer_id: userId, source: 'influencer_list' });
          await dispatch(deleteInfluencer(userId)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Hapus User Influencer' });
          dispatch(getTotalInfluencer());
        } catch (error) {
          showToast({ type: 'error', message: 'Gagal Hapus User Influencer' });
        } finally {
          dispatch(getInfluencer(page));
          setShowSpinner(false);
        }
      },
    });
  };

  const handleDetail = (e) => {
    const userId = e.target.parentElement.parentElement.dataset['key'];
    // dispatch(fetchCustomerInfo(userId));
    navigate(`${userId}`);
  };

  const handleCopy = async (e) => {
    const userId = e.target.parentElement.parentElement.dataset['key'];

    const filteredUserById = list.users.filter((item) => item.id === userId);
    const domain = window.location.origin;
    const excludeStringBackOffice = domain.replace('backoffices.', '');

    if (!filteredUserById.length) return;

    const link = `${excludeStringBackOffice}/event/${filteredUserById[0].referral}`;

    try {
      await navigator.clipboard.writeText(link);
      showToast({ type: 'success', message: 'Berhasil Copy Link Referral' });
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal Copy Link Referral' });
    }
  };

  const handlePageChange = (newPage) => {
    const updatedParams = Object.fromEntries(searchParams.entries());
    updatedParams.page = newPage;
    setSearchParams(updatedParams);
  };

  const DATA = list?.users?.map((item) => ({
    ...item,
    user_status: item.is_influencer_active ? 'active' : 'inactive',
    total_redeem: item?.redeem ? item.redeem : 0,
    total_commission: item?.commission ? item.commission : 0,
    active_period: getActivePeriod(item.influencer_expired_at),
    referral_link: generateReferralLink(item.referral),
  }));

  useEffect(() => {
    dispatch(getTotalInfluencer());
    dispatch(getTransactionStats());
  }, []);

  return (
    <div className="influencer">
      <div className="report-summary">
        <InfluencerStats />
        <TransactionStatsCard />
      </div>

      <div className="user">
        <ButtonAdd label="Tambah Influencer" onClick={handleAdd} />

        <TableWrapper title="Tabel User Influencer" icon={<PeopleIcon fill="#FF9900" width="25px" height="25px" />}>
          {isLoading ? (
            <LoadingSpinner />
          ) : list?.users?.length === 0 ? (
            <EmptyState />
          ) : (
            <>
              <Table
                column={COLUMN}
                data={DATA}
                actionBtn
                currentPage={page}
                onDetail={handleDetail}
                onDel={checkPermission(offCanvasMenu, currentMenu, 'delete') ? handleDelete : false}
                onCopy={handleCopy}
              />
              <PaginationTable
                currentPage={page}
                onPageChange={handlePageChange}
                totalCount={list?.pagination?.total_data}
              />
            </>
          )}
        </TableWrapper>
      </div>
    </div>
  );
};

export default InfluencerPage;

const getActivePeriod = (date) => {
  if (!date) return '-';

  const formattedDate = format(new Date(date), 'dd MMM yyyy');
  return formattedDate;
};

export const generateReferralLink = (referralCode) => {
  const domain = window.location.origin;
  const excludeStringBackOffice = domain.replace('backoffices.', '');

  return `${excludeStringBackOffice}/event/${encodeURIComponent(referralCode)}`;
};
